/** Scroll the first invalid field into view after a failed step/submit validation. */
export function scrollToFirstInvalidField(): void {
  requestAnimationFrame(() => {
    const el = document.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (!el) return;

    const scrollRoot = el.closest<HTMLElement>('[data-form-scroll-root]') ?? document.querySelector<HTMLElement>('[data-form-scroll-root]');

    if (scrollRoot) {
      scrollElementIntoContainer(el, scrollRoot);
    } else {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    const focusTarget = el.matches('input, select, textarea, button') ? el : el.querySelector<HTMLElement>('input, select, textarea, button');
    focusTarget?.focus({ preventScroll: true });
  });
}

function scrollElementIntoContainer(el: HTMLElement, container: HTMLElement): void {
  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const relativeTop = elRect.top - containerRect.top + container.scrollTop;
  const targetScroll = relativeTop - container.clientHeight / 2 + elRect.height / 2;
  container.scrollTo({ top: Math.max(0, targetScroll), behavior: 'smooth' });
}
